








































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { QInput } from 'quasar'
import api from 'src/assets/api/rest'
import { signIn } from 'src/boot/auth'

@Component
export default class AuthPaswordInput extends Vue {
  password = ''
  loading: boolean = false
  error: boolean = false

  @Prop(String)
  readonly email!: string

  @Ref()
  readonly input!: QInput

  async signIn () {
    if (this.password) {
      this.loading = true
      try {
        const response = await api.post('/api/sign-in/email-password', {
          email: this.email,
          password: this.password
        })
        const accessToken = await response.text()
        signIn(accessToken)
        this.$emit('signin')
      } catch (e) {
        this.error = true
        setTimeout(() => {
          this.password = ''
          this.error = false
          this.input.focus()
        }, 500)
      }
      this.loading = false
    }
  }

  async signInWithCode () {
    try {
      this.loading = true
      const response = await api.post('/api/sign-in/email', {
        email: this.email,
        locale: this.$i18n.locale,
        newcode: true
      })
      this.$emit('response', response)
    } catch (e) {
      this.password = ''
      this.error = true
      setTimeout(() => {
        this.error = false
        this.input.focus()
      }, 500)
    }
    this.loading = false
  }
}
